module.exports = __webpack_public_path__ + "img/payment.98a2c45e.gif";